import React from "react";
import { useFormik } from "formik";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import RiCloseCircleFill from "../../assets/icons/cross";
import MyForm from "../formComponent";
import { updatePasswordSchema } from "../../utils/validationSchemas";
import { successMsg } from "../../utils/toastMessage";
import { handleApiRequest } from "../../services/handleApiRequest";
import { updatePassword } from "../../redux/auth/thunk";

const defaultPasswordValues = {
  oldPassword: "",
  password: "",
  confirmPassword: "",
};
export const changePasswordFields = [
  { value: "oldPassword", type: "password", wrapperClassName: "mb-3" },
  { value: "password", type: "password", wrapperClassName: "mb-3" },
  { value: "confirmPassword", type: "password" },
];

export default function UpdatePassword({ userAction, setUserAction }) {
  const handleClose = () => {
    setUserAction({});
  };

  const handleUpdatePassword = async () => {
    const response = await handleApiRequest(updatePassword, values);

    if (response.status) {
      setUserAction(null);
      successMsg("Password updated successfully!!");
    }
  };

  const { values, errors, handleSubmit, handleChange, setFieldValue, isSubmitting } = useFormik({
    validateOnChange: false,
    validateOnBlur: false,
    initialValues: defaultPasswordValues,
    validationSchema: updatePasswordSchema,
    onSubmit: handleUpdatePassword,
  });

  return (
    <Modal
      show={userAction.action}
      onHide={handleClose}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Body>
        <div className="position-relative pt-4 px-2">
          <p
            className="pointer position-absolute"
            style={{ top: "-10px", right: "-10px" }}
            onClick={handleClose}>
            <RiCloseCircleFill
              className="icon-medium rounded-circle bg-black text-white p-2"
              style={{ strokeWidth: 1 }}
            />
          </p>

          <div className="text-start">
            <h4 className="mb-5 text-center">Update password!</h4>

            <Form className="" onSubmit={handleSubmit}>
              <div className="my-4">
                <MyForm
                  formFields={changePasswordFields}
                  values={values}
                  setFieldValue={setFieldValue}
                  errors={errors}
                  handleChange={handleChange}
                />
              </div>

              {isSubmitting ? (
                <button
                  className="secondaryBtn text-dark rounded py-1 mb-3 mt-4 w-100 text-white"
                  disabled>
                  Updating your password
                  <i className="growLoader spinner-grow ms-2" role="status" />
                </button>
              ) : (
                <div className="text-center">
                  <button type="submit" className="primaryBtn py-1 rounded w-50 mb-3 mt-4">
                    Update Password
                  </button>
                </div>
              )}
            </Form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
